import { useState, useEffect } from "react";
import { Pen2, FolderOpen, Calendar } from "@solar-icons/react/ssr";
import { Divider } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import { Helmet } from "react-helmet";

import { request } from "@/Api";

import ClientPopup from "@/clients/ClientPopup";
import { InternalLink, PageTitle } from "@/common/CommonComponents";
import EntityCreateButton from "@/common/EntityCreateButton";
import { Heading } from "@/common/typography";
import { FLOAT_BASE_URL, FORECAST_BASE_URL } from "@/config";
import CustomTable, { CustomRow } from "@/table/CustomTable";

export default function Clients() {
    const [clients, setClients] = useState([]);
    const [activeClient, setActiveClient] = useState({});
    const [popupOpen, setPopupOpen] = useState(false);
    const [order, setOrder] = useState("+name");

    const getClients = () => {
        request.get("clients").then((response) => {
            setClients(response.data);
        });
    };

    useEffect(getClients, []);
    return (
        <>
            <Helmet>
                <PageTitle title="Clients" />
            </Helmet>
            <Heading style={{ marginBottom: 30, paddingTop: 12 }}>
                Clients
            </Heading>
            <CustomTable
                headCells={[
                    { id: "name", label: "Client Name" },
                    { id: "currency", label: "Currency" },
                    { id: "_edit", label: "Edit" },
                ]}
                setOrder={setOrder}
                order={order.substring(1)}
                sign={order.substring(0, 1)}
                rows={clients}
                rowComponent={(client) => (
                    <CustomRow>
                        <TableCell component="th" scope="row">
                            {client.name}
                        </TableCell>
                        <TableCell align="left">{client.currency}</TableCell>
                        <TableCell align="left">
                            <Tooltip title="Client details">
                                <InternalLink href={`/departments/${client.id}`}>
                                    <IconButton>
                                        <Pen2 />
                                    </IconButton>
                                </InternalLink>
                            </Tooltip>
                            {client.google_drive_folder_id ? (
                                <Tooltip title="Client folder">
                                    <IconButton
                                        onClick={() =>
                                            window.open(
                                                "https://drive.google.com/drive/folders/" +
                                                client.google_drive_folder_id,
                                                "_blank",
                                            )
                                        }
                                        aria-label="client-folder"
                                    >
                                        <FolderOpen />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                            {client.forecast_id || client.float_id ? (
                                <Tooltip
                                    title={`Open in ${client.float_id ? "Float" : "Forecast"}`}
                                >
                                    <IconButton
                                        onClick={() =>
                                            window.open(
                                                client.float_id
                                                    ? `${FLOAT_BASE_URL}/?client=${encodeURIComponent(client.name)}`
                                                    : `${FORECAST_BASE_URL}/clients/${client.forecast_id}/edit/`,
                                                "_blank",
                                            )
                                        }
                                        aria-label="client-folder"
                                    >
                                        <Calendar />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                        </TableCell>
                    </CustomRow>
                )}
            />

            <ClientPopup
                isNew={activeClient.id == undefined}
                popupOpen={popupOpen}
                setPopupOpen={setPopupOpen}
                clients={clients}
                setClients={setClients}
                activeClient={activeClient}
            />

            <Divider sx={{ marginTop: 2, marginBottom: 2 }} />

            <EntityCreateButton
                setPopupOpen={() => {
                    setPopupOpen(true);
                    setActiveClient({});
                }}
            />
        </>
    );
}
